import Text from 'components/shared/Text'
import styled from 'styled-components/macro'

export const Label = styled(Text)`
    width: 46px;
`
